<!--
 * @Description: 
 * @Author: xuks
 * @Date: 2020-03-08 11:30:25
 * @LastEditTime: 2020-03-08 15:44:00
 -->
<template>
  <div class="home">
    <van-overlay :show="loading">
      <div class="load-wp">
        <van-loading
          size="38px"
          color="#69E09F"
        >加载中...</van-loading>
      </div>
    </van-overlay>
    <banner-cp
      :banner="cp_banner"
      v-if="cp_banner"
    ></banner-cp>
    <div
      class="currVersion"
      v-if="menuId==0"
    >
      当前版本：
      <span>{{currVersion}}</span>
      <i @click="resetGradeInfo">点击切换</i>
    </div>
    <div
      class="currVersion"
      v-else
    >
      当前年级：
      <span>{{currVersion}}</span>
      <i @click="resetGradeInfo">点击切换</i>
    </div>
    <ul class="navMenu" style="font-size: 95%;">
      <li
        :class="{hover:menuId==0}"
        @click="setMenuId(0)"
      >
        <a>同步学习</a>
      </li>
      <li
        :class="{hover:menuId==1}"
        @click="setMenuId(1)"
      >
        <a>提高培优</a>
      </li>
      <li
        :class="{hover:menuId==2}"
        @click="setMenuId(2)"
      >
        <a>防疫专区</a>
      </li>
      <li
        :class="{hover:menuId==3}"
        v-if="bookID.length>0"
        @click="setMenuId(3)"
      >
        <a>校本视频</a>
      </li>
    </ul>
    <div
      class="navContent"
      v-show="menuId==0"
    >
      <van-tabs
        v-model="tabIndex"
        @click="changTab"
        
      >
        <van-tab
          v-for="(itm,idx) in params.editionSelectResult"
          :title="itm.subjectName"
          :name="itm.subjectId"
          :key="idx"
        >
          <ul
            class="unitList"
            v-for="(unit,index) in childrens"
            :key="index"
          >
            <h1
              v-html="unit.name"
              v-if="unit.childrens!=undefined && unit.childrens.length>0"
            ></h1>
            <h1
              class="colorGray"
              @click="lockTips"
              v-html="unit.name"
              v-else
            ></h1>
            <li
              v-for="(course,index1) in unit.childrens"
              :key="index1"
            >
              <div v-if="course.mark=='目标' && course.contentPos>-1">
                <div
                  class="target"
                  v-if="course.contentPos>-1 && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                  @click="goTarget(itm.subjectId,course.contentPos)"
                >
                  <i class="icoTarget"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  class="target"
                  v-else
                >
                  <i class="icoTarget colorGray"></i>
                  <span v-text="course.name"></span>
                </div>
              </div>
              <div v-if="course.mark=='复习'">
                <div
                  class="target"
                  v-if="(course.childrens.tongbu.childrens.length>0 || course.childrens.tigao.childrens.length>0 || course.childrens.lianxi.childrens.length>0) && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                  @click="toggleCourse($event)"
                >
                  <i class="icoHistory"></i>
                  {{course.name}}
                  <em @click="toggleCourse2($event)"></em>
                </div>
                <div
                  class="target"
                  @click="lockTips"
                  v-else
                >
                  <i class="icoHistory colorGray"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  class="switchVideoMenu"
                  v-if="(course.childrens.tongbu.childrens.length>0 || course.childrens.tigao.childrens.length>0 || course.childrens.lianxi.childrens.length>0) && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                >
                  <ul class="videoMenu">
                    <li
                      v-for="(lession,index2,i) in course.childrens"
                      :key="i"
                      :class="{hover:(i==0 && course.childrens.tongbu.childrens.length>0) || (i==1 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length>0) || (i==2 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length==0 && course.childrens.lianxi.childrens.length>0)}"
                      v-if="lession.childrens!=undefined && lession.childrens.length>0"
                      @click="switchVideoMenu($event,i,lession.name)"
                    >
                      <i
                        class="playIco"
                        v-if="index2!='lianxi'"
                      ></i>
                      <i
                        class="lianxi"
                        v-else
                      ></i>
                      <span>{{lession.name}}</span>
                    </li>
                  </ul>
                  <div
                    class="videoItem"
                    v-for="(lession,index2,i) in course.childrens"
                    :key="i"
                    :class="{hover:(i==0 && course.childrens.tongbu.childrens.length>0) || (i==1 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length>0) || (i==2 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length==0 && course.childrens.lianxi.childrens.length>0)}"
                    v-if="lession.childrens!=undefined && lession.childrens.length>0"
                  >
                    <div v-if="lession.name!='课后练习'">
                      <ul v-for="(cart,index3) in lession.childrens">
                        <h1 @click="toggleCart($event)" v-html="cart.name">
                          <i @click="toggleCart2($event)"></i>
                        </h1>
                        <li
                          v-for="(book,index4) in cart.childrens"
                          :key="index4"
                          :class="{currColor:(currSubCourseName && currVideoId==book.videoCode && currVideoName==book.showName && currSubCourseName==course.name) || (!currSubCourseName && currVideoId==book.videoCode && currVideoName==book.showName)}"
                          @click="goPlayVideo(book.videoCode,book.videoType,book.contentPos,unit.childrens,book.jiangyiPos,book.showName,course.name)"
                        >
                          <i class="icoPlay"></i>
                          <span v-text="book.showName"></span>
                        </li>
                      </ul>
                    </div>
                    <div v-else>
                      <ul>
                        <li
                          v-for="(cart,index3) in lession.childrens"
                          @click="goExam(cart.name,cart.contentPos,cart.mark)"
                          :class="{pt0: index3==0}"
                        >
                          <i class="icoLianxi2"></i>
                          {{cart.name}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="course.mark=='学'">
                <h1
                  v-if="(course.childrens.tongbu.childrens.length>0 || course.childrens.tigao.childrens.length>0 || course.childrens.lianxi.childrens.length>0) && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                  v-html="course.name"
                  @click="toggleCourse($event)"
                >
                  <i @click="toggleCourse2($event)"></i>
                </h1>
                <h1
                  v-else
                  class="colorGray"
                  @click="lockTips"
                  v-html="course.name"
                ></h1>
                <div
                  class="switchVideoMenu"
                  v-if="(course.childrens.tongbu.childrens.length>0 || course.childrens.tigao.childrens.length>0 || course.childrens.lianxi.childrens.length>0) && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                >
                  <ul class="videoMenu">
                    <li
                      v-for="(lession,index2,i) in course.childrens"
                      :key="i"
                      :class="{hover:(i==0 && course.childrens.tongbu.childrens.length>0) || (i==1 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length>0) || (i==2 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length==0 && course.childrens.lianxi.childrens.length>0)}"
                      v-if="lession.childrens.length>0"
                      @click="switchVideoMenu($event,i,lession.name)"
                    >
                      <i
                        class="playIco"
                        v-if="index2!='lianxi'"
                      ></i>
                      <i
                        class="lianxi"
                        v-else
                      ></i>
                      <span>{{lession.name}}</span>
                    </li>
                  </ul>
                  <div
                    class="videoItem"
                    v-for="(lession,index2,i) in course.childrens"
                    :key="i"
                    :class="{hover:(i==0 && course.childrens.tongbu.childrens.length>0) || (i==1 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length>0) || (i==2 && course.childrens.tongbu.childrens.length==0 && course.childrens.tigao.childrens.length==0 && course.childrens.lianxi.childrens.length>0)}"
                    v-if="lession.childrens.length>0"
                  >
                    <div v-if="lession.name!='课后练习'">
                      <ul v-for="(cart,index3) in lession.childrens">
                        <h1 @click="toggleCart($event)" v-html="cart.name">
                          <i @click="toggleCart2($event)"></i>
                        </h1>
                        <li
                          v-for="(book,index4) in cart.childrens"
                          :key="index4"
                          :class="{currColor:(currSubCourseName && currVideoId==book.videoCode && currVideoName==book.showName && currSubCourseName==course.name) || (!currSubCourseName && currVideoId==book.videoCode && currVideoName==book.showName)}"
                          @click="goPlayVideo(book.videoCode,book.videoType,book.contentPos,unit.childrens,book.jiangyiPos,book.showName,course.name)"
                        >
                          <i class="icoPlay"></i>
                          <span v-text="book.showName"></span>
                        </li>
                      </ul>
                    </div>
                    <div v-else>
                      <ul>
                        <li
                          v-for="(cart,index3) in lession.childrens"
                          @click="goExam(cart.name,cart.contentPos,cart.mark)"
                          :class="{pt0: index3==0}"
                        >
                          <i class="icoLianxi2"></i>
                          {{cart.name}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="course.mark=='练习'">
                <div
                  v-if="course.contentPos>-1 && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                  class="test53"
                  @click="goExam(course.name,course.contentPos,'练习')"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  v-else
                  class="test53 colorGray"
                  @click="lockTips"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
              </div>
              <div v-if="course.mark=='答案'">
                <div
                  v-if="course.contentPos>-1 && (unitNo==-1 || (unitNo>0 && index<unitNo))"
                  class="test53"
                  @click="goExamAnswer(itm.subjectId,course.name,course.contentPos)"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
                <div
                  v-else
                  class="test53 colorGray"
                  @click="lockTips"
                >
                  <i class="ico53"></i>
                  <span v-text="course.name"></span>
                </div>
              </div>
            </li>
          </ul>
        </van-tab>
      </van-tabs>
    </div>
    <special
      v-if="menuId==1"
      :specialParams="specialParams"
      :lessonId="params.lessonId"
    ></special>
    <prevent-epidemic
      v-if="menuId==2"
      :preventEpidemicParams="specialParams"
      :lessonId="params.lessonId"
    ></prevent-epidemic>
    <school-based v-if="menuId==3" :book-id="bookID" :lessonId="params.lessonId"></school-based>
      <askMore :show="showAskMore" @close="showAskMore = false"></askMore>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper';
import { baseUrl, cd_baseUrl, baseApi3 } from '@/assets/js/api'
import special from '../components/Special';
import preventEpidemic from '../components/preventEpidemic';
import SchoolBased from '../components/SchoolBased';
import bannerCp from '@/components/common/Banner'
import askMore from "@/components/common/askMore";
var _timer = null;

var cm = {
    openClose: function (e) {
        $(e).toggleClass('hover');
        $(e).next('ul').toggle();
    },
    openMore: function (e) {
        $(e).toggleClass('hide');
        $(e).parent().find(".icoTg").removeClass("hide");
    }
}
export default {
    name: 'Home',
    components: {
        special,
        preventEpidemic,
        SchoolBased,
        bannerCp,
        askMore
    },
    data () {
        return {
            loading: true,
            banner: '',
            phone: '',
            wxUrls: [],
            showAskMore: false,
            currVersion: '',
            params: {
                editionSelectResult: [{
                    subjectId: '1',
                    subjectName: "语文",
                    editions: [{
                        editionId: 1,
                        editionName: "北师大版"
                    }]
                }],
                gradeSelectResult: {
                    gradeName: "二年级",
                    gradeId: "2"
                },
                eduSystemId: '2',//学制
                lessonId: ''
            },
            childrens: [],
            contents: [],
            courseName: '',
            specialParams: {
                gradeId: 2,
                phaseId: 2,
                subjectMap: { "1": 2, "2": 2, "3": 32 },
                version: 2,
            },
            //后续修改
            fangyiNewTag: false,
            backTopShow: false,
            baseUrl2: 'https://resource.youxuepai.com',
            baseUrl: 'https://prelearn.youxuepai.com',
            baseUrl1: 'http://sbctest.youxuepai.com',
            baseUrl3: 'http://192.168.8.34:8080',
            tabBarId: 0,
            sTitle1: '请选择年级',
            sTitle2: '请选择教材版本',
            unitNo: -1,
            xuezhi: sessionStorage.c_yxpXuezhi || '六三制',
            grades: [{ id: 1, name: '一年级' }, { id: 2, name: '二年级' }, { id: 3, name: '三年级' }, { id: 4, name: '四年级' }, { id: 5, name: '五年级' }, { id: 6, name: '六年级' }, { id: 7, name: '七年级' }, { id: 8, name: '八年级' }, { id: 9, name: '九年级' }],
            gradeId: sessionStorage.c_yxpGradeId || '',
            gradeName: sessionStorage.c_yxpGradeName || '',
            selectStep: sessionStorage.c_selectStep || 1,
            currEditions: [],
            currEditionObj: sessionStorage.c_currEditionObj == undefined ? {} : JSON.parse(sessionStorage.c_currEditionObj),
            currEditionName: '',
            contentHost: '',
            msg: '网络数据请求异常',
            mainerHeight: 'auto',
            menuId: 0, // 一级菜单 [同步学习，提高培优，防疫专区，……]
            tabIndex: 0, // 二级菜单 [语文，数学，……]
            zhuantiLists: [],
            fangyiLists: [],
            currVideoId: '',
            currVideoName: '',
            currSubCourseName: '',
            bookID: [],
            isInit: true,
            scrollTop: 0,
        }
    },
    created () {
        var that = this;
        this.params =Object.assign({},paramsHelper.decode(this.$route.query.params))
        let { gradeSelectResult, editionSelectResult, eduSystemId, lessonId } = this.params
        this.currVersion = gradeSelectResult.gradeName + ' ' + editionSelectResult[0].editions[0].editionName+' ' +
            (editionSelectResult[0].editions[0].termActive ===1 ? '上册' : '下册');
        this.currText = this.currVersion;//保存一份
        Object.assign(this.specialParams, {
            gradeId: gradeSelectResult.gradeId,
            phaseId: this.getPhaseId(gradeSelectResult.gradeId, eduSystemId)
        })
        let isGetCourseContent = false;
        let localData = localStorage.getItem(that.params.lessonId);
        if(localData) {
            localData = JSON.parse(localData);
            if(localData.extra) {
                const extra = localData.extra;
                // menuId: 0, // 一级菜单 [同步学习，提高培优，防疫专区，……]
                // tabIndex: 0, // 二级菜单 [语文，数学，……]
                this.menuId = extra.menuId || 0;
                if(this.menuId === 0) this.isInit = false;
                this.tabIndex = extra.tabIndex || 0;
                this.changTab(this.tabIndex, 'nosave');
                isGetCourseContent = true;
            }
        }
        if(!isGetCourseContent) {
            this.getCourseContent(gradeSelectResult.gradeId, eduSystemId, editionSelectResult[0].subjectId,
                editionSelectResult[0].editions[0].editionId, editionSelectResult[0].editions[0].termActive);
        }
        this.getSchoolBasedId(lessonId, gradeSelectResult.gradeId);
        //深圳修改增加
        // _timer = window.setInterval(function () {
        //     that.initHeight();
        //     if (that.$refs.fangyiNew && that.$refs.fangyiNew.length > 0) {
        //         that.fangyiNewTag = true;
        //     }
        // }, 100);
        var i = 0;
        for (var k in that.currEditionObj) {
            if (i == that.tabIndex) {
                that.currEditionName = that.currEditionObj[k].editionName;
            }
            i++;
        }
        if (sessionStorage.c_tabIndex != undefined && that.menuId == 0) {
            window.setTimeout(function () {
                if ($(".currColor").text() != '') {
                    $(".currColor").parent().parent().parent().addClass("hover").siblings(".videoItem").removeClass("hover");
                    var n = 0;
                    $(".currColor").parent().parent().parent().parent().children(".videoItem").each(function (i) {
                        if ($(this).hasClass("hover")) {
                            n = i;
                        }
                    });
                    $(".currColor").parent().parent().parent().parent().children(".videoMenu").eq(0).children("li").removeClass("hover").eq(n).addClass("hover");
                    var _t = $(".currColor").eq(0).parent().parent().parent().offset().top - 60;
                    $(window).scrollTop(_t);
                }
            }, 1000);
        }
    },
    computed: {
        cp_banner () {
            return sessionStorage.getItem('banner')
        },
    },
    watch: {
    },
    beforeRouteLeave(to, from, next) {
        this.saveLocalData();
        next();
    },
    methods: {
        saveLocalData(reset) {
            const localData = Object.assign({}, this.params, {
                extra: {
                    menuId: this.menuId,
                    tabIndex: this.tabIndex,
                    scrollTop: reset ? 0 : document.documentElement.scrollTop || document.body.scrollTop,
                }
            });
            localStorage.setItem(this.params.lessonId, JSON.stringify(localData));
        },
        //深圳修改
        toggleCourse: function (e) {
            $(e.target).toggleClass("hover");
            $(e.target).next(".switchVideoMenu").toggle();
        },
        toggleCourse2: function (e) {
            $(e.target).parent().toggleClass("hover");
            $(e.target).parent().next(".switchVideoMenu").toggle();
        },
        toggleCart: function (e) {
            $(e.target).toggleClass("hover");
            $(e.target).parent().children("li").toggle();
        },
        toggleCart2: function (e) {
            $(e.target).parent().toggleClass("hover");
            $(e.target).parent().parent().children("li").toggle();
        },
        switchVideoMenu: function (e, i, name) {
            var n = 0;
            $(e.currentTarget).parent().children("li").each(function (k) {
                if ($(this).text().replace(/\s/g, '') == name) {
                    n = k;
                }
            });
            $(e.currentTarget).parent().children("li").removeClass("hover").eq(n).addClass("hover");
            $(e.currentTarget).parent().parent().children(".videoItem").removeClass("hover").eq(n).addClass("hover");
        },


        //深圳修改结束
        openClose: function (e) {
            $(e.currentTarget).toggleClass('hover');
            $(e.currentTarget).next('ul').toggle();
        },
        openMore: function (e) {
            $(e.currentTarget).toggleClass('hide');
            $(e.currentTarget).parent().find(".icoTg").removeClass("hide");
        },
        setMenuId (id) {
            let { gradeSelectResult, editionSelectResult, eduSystemId } = this.params;
            if (id === 0) {
                this.currVersion = this.currText
            } else {
                this.setCurrVersion(gradeSelectResult.gradeName)
            }
            this.menuId = id;
            Object.assign(this.specialParams, {
                gradeId: gradeSelectResult.gradeId,
                phaseId: this.getPhaseId(gradeSelectResult.gradeId, eduSystemId)
            })
            this.saveLocalData(true);
        },
        setCurrVersion (gradeName, editionName = '', termActive) {
            this.currVersion = gradeName + ' ' + editionName + ' ' + (!termActive ? '' : (termActive ===1 ? '上册' : '下册'));
        },
        resetGradeInfo () {
            sessionStorage.setItem('goback', true);
            this.$router.push({
                name: 'GradeSelect',
                query: { lessonId: this.params.lessonId || '' }
            })
        },
        changTab (name, title) {
            let { gradeSelectResult, editionSelectResult, eduSystemId } = this.params;
            let obj = {
              editionId: 0,
              editionName: "",
              termActive: 0,
              active: 0,
            }
            if(editionSelectResult.filter(itm => itm.subjectId === name).length){
              Object.assign(obj, editionSelectResult.filter(itm => itm.subjectId === name)[0].editions[0])
            }
            let { editionName, editionId, termActive } = obj;
            this.setCurrVersion(gradeSelectResult.gradeName, editionName, termActive)
            this.getCourseContent(gradeSelectResult.gradeId, eduSystemId, name, editionId, termActive);
            if(title !== 'nosave') {
                this.saveLocalData(true);
            }
        },
        goPlayVideo (videoId, videoType, pos, unitObj) {
            sessionStorage.c_unitObj = JSON.stringify(unitObj);
            this.$router.push({
                name: 'Video',
                query: { params: paramsHelper.encode({ videoId, videoType, pos, courseName: this.courseName }), lessonId: this.params.lessonId || '' }
            })
        },
        goTarget (pos) {
            this.$router.push({
                name: 'Target',
                query: { pos, lessonId: this.params.lessonId || '' }
            })
        },
        goExam (name, pos, mark) {
            if (mark == '练习') {
                this.$router.push({
                    name: 'Exam',
                    query: { params: paramsHelper.encode({ name, pos }), lessonId: this.params.lessonId || '' }
                })
            } else {
                this.$router.push({
                    name: 'ExamAnswer',
                    query: { params: paramsHelper.encode({ pos }), lessonId: this.params.lessonId || '' }
                })
            }

        },
        goExamAnswer: function (subjectId, name, pos) {
            this.$router.push({
                name: 'ExamAnswer',
                query: { params: paramsHelper.encode({ pos }), lessonId: this.params.lessonId || '' }
            })
        },
        lockTips () {
            /*this.$Dialog.alert({
                confirmButtonText: '知道了',
                message: '进一步了解详情<br>请咨询教育顾问'
            }).then(() => {
                // on close
            });*/
            this.showAskMore = true;
        },
        getPhaseId (gradeId, eduSystemId) {
            var phaseId = 2;
            if (eduSystemId == 1) {//六三学制
                if (gradeId < 7) {
                    phaseId = 2;
                } else if (gradeId > 6 && gradeId < 10) {
                    phaseId = 3;
                } else { }
            } else {
                if (gradeId < 6) {
                    phaseId = 2;
                } else if (gradeId > 5 && gradeId < 10) {
                    phaseId = 3;
                } else { }
            }
            return phaseId;
        },
        getSchoolBasedId(lessonId, gradeId){
            var that = this;
            this.$axios.get(cd_baseUrl + '/microClassCustom/link/lesson/getBookId', {
                params: {
                    lessonId,
                    gradeId,
                }
            }).then(function (res) {
                if (res && res.data.errcode === 0) {
                    that.bookID = res.data.data.bookId;
                } else {
                    that.$toast(res.data.errmsg)
                }
                that.loading = false
            }).catch(function (err) {
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
        getCourseContent (gradeId, eduSystemId, subjectId, editionId, termId) {
            var that = this;
            that.loading = true;
            this.$axios.get(baseApi3 + '/api/course-make/microClassCustom/link/getContent', {
                params: {
                    gradeId: gradeId,
                    phaseId: that.getPhaseId(gradeId, eduSystemId),
                    subjectId: subjectId,
                    termId: termId,
                    editionId: editionId,
                    version: 2,
                    xuezhi: eduSystemId,	//1:六三  2:五四
                    id: 0,
                    dianziFlag: 1,
                    lessonId: this.params.lessonId,
                }
            }).then( res => {
                that.loading = false;
                let { msg, value } = res.data
                if (res && msg === 'success') {
                    that.loading = false;
                    let { contents, childrens, host, id, name } = value;

                    var childrens2 = childrens, newChildrens2 = [];
                    if (childrens2 != undefined) {
                        childrens2.forEach(function (item3, index3) {//第二层  单元
                            var obj3 = {};
                            obj3.name = item3.name;
                            var childrens3 = item3.childrens,
                                newChildrens3 = [];
                            childrens3.forEach(function (item4, index4) {//第三层 阶段分类
                                var obj4 = {};
                                for (var k in item4) {
                                    if (k == 'childrens' && (item4.mark == '学' || item4.mark == '复习')) {
                                        var childrens4 = item4.childrens,
                                            newChildrens4 = {};
                                        newChildrens4.tongbu = {};
                                        newChildrens4.tongbu.name = '同步视频';
                                        newChildrens4.tongbu.childrens = [];
                                        newChildrens4.tigao = {};
                                        newChildrens4.tigao.name = '同步提高';
                                        newChildrens4.tigao.childrens = [];
                                        newChildrens4.lianxi = {};
                                        newChildrens4.lianxi.name = '课后练习';
                                        newChildrens4.lianxi.childrens = [];
                                        childrens4.forEach(function (item5, index5) {//第四层 视频分类
                                            if (item5.mark.indexOf('基础') != -1) {
                                                newChildrens4.tongbu.childrens.push(item5);
                                            } else if (item5.mark.indexOf('提高') != -1) {
                                                newChildrens4.tigao.childrens.push(item5);
                                            } else if (item5.mark.indexOf('练习') != -1 || item5.mark.indexOf('答案') != -1) {
                                                newChildrens4.lianxi.childrens.push(item5);
                                            } else { }
                                        });
                                        obj4[k] = newChildrens4;
                                    } else {
                                        obj4[k] = item4[k];
                                    }
                                }
                                newChildrens3.push(obj4);
                            });
                            obj3.childrens = newChildrens3;
                            newChildrens2.push(obj3);
                        });

                    }

                    Object.assign(that, {
                        contents,
                        childrens: newChildrens2,
                        contentHost: host,
                        courseName: name
                    });
                    sessionStorage.setItem('c_contentContents', JSON.stringify(contents))//用于后续视频播放内容及单元目标数据等
                    sessionStorage.setItem('c_host', host);
                    this.$nextTick(() => {
                        let localData = localStorage.getItem(that.params.lessonId);
                        if(localData) {
                            localData = JSON.parse(localData);
                            if(localData.extra) {
                                const extra = localData.extra;
                                this.menuId = extra.menuId || 0;
                                if(this.menuId === 0) this.isInit = false;
                                this.tabIndex = extra.tabIndex || 0;
                                document.documentElement.scrollTop = extra.scrollTop || 0;
                                document.body.scrollTop = extra.scrollTop || 0;
                                this.scrollTop = extra.scrollTop || 0;
                            }
                        }
                    })
                } else {
                    that.$toast(msg || '系统出错，请联系管理员');
                }
            }).catch(function (err) {
                that.loading = false;
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
    }
}
</script>

<style lang="less" >
.home {
   .van-tabs__nav{
    flex-wrap: wrap;
    padding-bottom: 0px;
    .van-tab{
        width: calc(100% / 3);
        flex: 0 auto;
        margin-bottom: 15px;
        .van-tab__text{
          padding-bottom: 0px !important;
          margin-bottom: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
    }
  }
}
</style>


